import React from "react"
import types from "prop-types"
import Sidebar from "shared/Sidebar"
import ReportIndexSidebarOwnershipSection from "./ReportIndexSidebarOwnershipSection"
import ReportIndexSidebarSftpSection from "./ReportIndexSidebarSftpSection"
import ReportIndexSidebarSolutionSection from "./ReportIndexSidebarSolutionSection"

const ReportIndexSidebar = ({ hiddenSidebar }) => (
  <Sidebar hiddenSidebar={hiddenSidebar}>
    <ReportIndexSidebarSolutionSection />
    <ReportIndexSidebarSftpSection />
    <ReportIndexSidebarOwnershipSection />
  </Sidebar>
)

ReportIndexSidebar.propTypes = {
  hiddenSidebar: types.bool.isRequired,
}

export default ReportIndexSidebar
